// import { css } from '@emotion/core'
import styled, { Theme } from '@themes/theme'
import { ChatArea, NavBottomPadding, preventScrollStyle } from '@styles/base.style'
import { css } from '@emotion/core'

export const MoneyStyle = styled.span`
  float: right;
  position: relative;
  top: 1px;
  width: 16px;
  margin-left: 4px;
`
export const MoneyHistoryWrap = styled.div`
  ${ChatArea};
  position: relative;
  top: 0;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 126px);
  border-radius: 0;
  background: ${props => props.theme.color.modalBg};
  &:not(.pc-money-history-wrap) {
    padding-bottom: ${NavBottomPadding};
  }
  &.pc-money-history-wrap {
    min-height: 100%;
  }
  .money-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 54px;
    padding: 16px 21px;
    background: ${props => props.theme.color.modalBg};
    border-top: 1px solid #BCC0C330;
    &--txt {
      flex:1;
      font-size: ${props => props.theme.font.title};
      font-weight: ${props => props.theme.fontW.bold};
      color: ${props => props.theme.color.modalTxt};
    }
    &--money-wrap {
      flex: 3;
      display: inline-flex;
      align-items: center;
      &--num {
        display: inline-block;
        width: 100%;
        text-align: right;
        font-size: ${props => props.theme.font.title};
        font-weight: ${props => props.theme.fontW.bold};
        color: ${props => props.theme.color.modalTxt};
      }
    }
  }
`
export const ActivityHistoryWrap = styled.div`
  position: relative;
  z-index: 1;
  border-radius: 0;
  background: ${props => props.theme.color.modalBg};
  &.activity-history-popup {
    height: 100%;

    .activity-history-list {
      height: auto;
      padding: 0;
      overflow-x: hidden !important;
      ${preventScrollStyle};
      .list-view-section-body {
        margin-bottom: 100px;
      }
      &.popup {
        height: calc(100vh - 45px);
        &.pc {
          height: 100%;
        }
      }
      &::before {
        content: '';
        display: block;
        clear: both;
      }
    }
  }
  &:not(.pc) {
    padding-bottom: ${NavBottomPadding};
  }
  .money-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 54px;
    padding: 16px 21px;
    background: ${props => props.theme.color.modalBg};
    border-top: 1px solid #BCC0C330;
    &--txt {
      flex:1;
      font-size: ${props => props.theme.font.title};
      font-weight: ${props => props.theme.fontW.bold};
      color: ${props => props.theme.color.modalTxt};
    }
    &--money-wrap {
      flex: 3;
      display: inline-flex;
      align-items: center;
      &--num {
        display: inline-block;
        width: 100%;
        text-align: right;
        font-size: ${props => props.theme.font.title};
        font-weight: ${props => props.theme.fontW.bold};
        color: ${props => props.theme.color.modalTxt};
      }
    }
  }
`

export const MoneyHistoryItemWrap = styled.div`
  .ant-collapse {
    background: ${props => props.theme.color.modalBg};
    border-bottom: 1px solid ${props => props.theme.color.modalSubBg2} !important;
    &.active-score-history {
      border-bottom: none !important;
    }
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 0;
  }
  .ant-collapse-item-active .money-history-list--wrap--txt + svg {
    transform: rotate(180deg);
  }
  .ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 14px 21px;
    background: ${props => props.theme.color.modalSubBg};
  }
  .ant-collapse-borderless > .ant-collapse-item {
    border: none;
    background: ${props => props.theme.color.modalBg};
  }
  .ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
    padding-left: 0;
  }
  .date-wrap {
    height: 34px;
    line-height: 3.4rem;
    padding: 0 21px;
    color: ${props => props.theme.color.modalTxt};
    background: ${props => props.theme.color.modalSubBg};
    .score-summary {
      color: ${props => props.theme.color.modalTxt};
      margin-left: 4px;
    }
    &.activity-score {
      display: flex;
      justify-content: space-between;
      .score-summary {
        color: ${props => props.theme.color.modalgray};
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.bold};
      }
    }
  }
  .money-history-list {
    display:flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 65px;
    padding: 2px 21px;
    background: ${props => props.theme.color.modalBg};
    &--wrap {
      flex: 2;
      display: inline-flex;
      align-items: center;
      &--time {
        margin-right: 10px;
        color: ${props => props.theme.color.modalgray};
        font-weight: ${props => props.theme.fontW.medium};
      }
      &--txt {
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.large};
        & + svg {
          width: 16px;
          height: auto;
          margin-left: 5px;
          path {
            &#bg {
              fill: ${props => props.theme.color.modalSubBg};
            }
            &#arrow {
              fill: ${props => props.theme.color.modalSubTxt};
            }
          }
        }
      }
      &--num {
        width: calc(100% - 14px);
        text-align: right;
        font-size: ${props => props.theme.font.large};
      }
      &.num {
        flex: 1;
        display: inline-flex;
        align-items: center;
        text-align: right;
        svg {
          width: 16px;
          margin-left: 4px;
        }
      }
    }
  }
  // 활동점수 내역 스타일
  .active-score-history-list {
    display:flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 65px;
    padding: 2px 21px;
    background: ${props => props.theme.color.modalBg};
    &:not(:last-of-type) {
      border-bottom: 1px solid #BCC0C330;
    }
    &--wrap {
      flex: 2;
      display: inline-flex;
      align-items: center;
      margin-top: 1px;
      // 활동점수 내역 스타일
      .location {
        width: 36px;
        height: auto;
        margin-right: 15px;
      }
      .txt-time-wrap {
        display: flex;
        flex-wrap: wrap;
      }
      &--time {
        margin-right: 10px;
        color: ${props => props.theme.color.gray};
        font-weight: ${props => props.theme.fontW.regular};
        transform: translateY(-1px);
      }
      &--txt {
        width: 100%;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.title};
        transform: translateY(5px);
        & + svg {
          width: 16px;
          height: auto;
          margin-left: 5px;
          path {
            &#bg {
              fill: ${props => props.theme.color.modalSubBg};
            }
            &#arrow {
              fill: ${props => props.theme.color.modalSubTxt};
            }
          }
        }
      }
      &--num {
        width: 100%;
        text-align: right;
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.modalTxt};
        margin-top: 1px;
      }
      .score-return-tag {
        width: 56px;
        height: 21px;
        border-radius: 4px;
        background:  ${props => props.theme.color.blue};
        color: ${props => props.theme.color.white};
        font-size: ${props => props.theme.font.small};
        font-weight: ${props => props.theme.fontW.medium};
        text-align: center;
        margin-left: auto;
        margin-right: -3px;
      }
      &.num {
        flex: 1;
        display: inline-flex;
        align-items: center;
        text-align: right;
        flex-wrap: wrap;
        svg {
          width: 16px;
          margin-left: 4px;
        }
      }
    }
  }
`
export const Gain = (theme: Theme) =>
  css`
    color: ${theme.color.red};
  `
export const Lose = (theme: Theme) =>
  css`
    color: ${theme.color.blue} !important;
  `

export const MoneyHistoryContentWrap = styled.div`
  .info-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    .date {
      color: ${props => props.theme.color.modalSubTxt};
      font-weight: ${props => props.theme.fontW.medium};
      .time {
        color: ${props => props.theme.color.modalgray};
        font-weight: ${props => props.theme.fontW.medium};
        margin-left: 4px;
      }
    }
    .go-club-btn {
      width: auto;
      height: 20px;
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.large};
      .arrow-ico {
        position: relative;
        display: inline-block;
        width: 5px;
        height: 5px;
        margin-left: 4px;
        transform: rotate(-45deg) scale(1.5) translate(1px, -1px);
        &::before, &::after {
          content:'';
          display: block;
          position: absolute;
          bottom: 0;
          right: 0;
          background: ${props => props.theme.color.modalTxt};
        }
        &::before {
          width: 100%;
          height: 1px;
        }
        &::after {
          width: 1px;
          height: 100%;
        }
      }
    }
  }

  .fold {
    display: inline-block;
    width: auto;
    height: 22px;
    line-height: 2.2rem;
    padding: 0 6px;
    text-align: center;
    border-radius: 4px;
    color: ${props => props.theme.color.themeTxt};
    background: ${props => props.theme.color.secondaryBg};
  }

  .bet-list-wrap {
    &--match-wrap {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 7px 0;
      border-bottom: 1px dashed ${props => props.theme.color.gray};
      &:nth-last-of-type(2) {
        border-bottom: 1px solid ${props => props.theme.color.gray};
      }
      &--team-wrap {
        flex: 3;
        max-width: 75%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
        &--team-name {
          max-width: 50%;
          color: ${props => props.theme.color.modalTxt};
        }
        &--vs {
          margin: 0 4px;
          color: ${props => props.theme.color.modalgray};
          font-size: ${props => props.theme.font.small};
        }
        &.result {
          flex:1;
          justify-content: flex-end;
          color: ${props => props.theme.color.modalTxt};
        }
      }
    }
    &--money-wrap {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      line-height: 3rem;
      &--num {
        color: ${props => props.theme.color.modalOrange};
        font-size: ${props => props.theme.font.large};
      }
      &--x {
        margin: 0 10px;
        font-size: 18px;
        font-weight: 400 !important;
        color: ${props => props.theme.color.modalgray};
      }
      &--money {
        float: right;
        max-width: calc(100% - 14px);
        text-align: right;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.large};
      }
      svg {
        width: 16px;
        margin-left: 4px;
      }
      &--equal {
        margin: 0 10px;
        text-align: center;
        color: ${props => props.theme.color.modalTxt};
      }
    }
  }

  .go-betting-history-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 36px;
    margin: 7px auto 0;
    border-radius: 4px;
  }
`
